<h2 mat-dialog-title>Salvar filtro favorito</h2>

<mat-dialog-content [formGroup]="form">
    <div class="field-block">
        <label class="field-label" for="nomeFavoritoInput">Nome do favorito</label>
        <mat-form-field appearance="outline" class="w-100 nome-favorito-field" subscriptSizing="dynamic">
            <input id="nomeFavoritoInput" matInput formControlName="nome" maxlength="120" autocomplete="off" placeholder="Informe o nome do favorito">
        </mat-form-field>
        @if (form.controls.nome.hasError('required') && form.controls.nome.touched) {
            <mat-error>Informe o nome do favorito.</mat-error>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button class="btn-secondary" mat-dialog-close type="button">Cancelar</button>
    <button mat-flat-button class="btn-primary" type="button" (click)="confirmar()">Salvar</button>
</mat-dialog-actions>
